import React from 'react';
import * as Immutable from "immutable";
import ImmutablePropTypes from 'react-immutable-proptypes';
import {connect} from 'react-redux'
import store from '../../model/reducers/store';
import {Keys} from '../../model/constants';

const isLoggedIn = (s) => {
    return s.loginState.get(Keys.LoginStateMeta.LOGGED_IN, false);
};
const isInitialized = (s) => {
    return isLoggedIn(s) && (s.assigneesState.get(Keys.StoreSliceMeta.LAST_LOAD_SUCCESS, false)
           && s.workSessionsState.get(Keys.StoreSliceMeta.LAST_LOAD_SUCCESS, false)
           && s.workSessionTemplatesState.get(Keys.StoreSliceMeta.LAST_LOAD_SUCCESS, false)
        )
};
const isActive = (s) => {
    return isInitialized(s) && s.currentWorkSessionState.get(Keys.StoreSliceMeta.LAST_LOAD_SUCCESS, false)
};

const hasPermission = (p, account) => {
    if( !p ) {
        return true;
    }
    return account && account.has('permissions')?account.get('permissions').check(p):false;
}

export const checkActive = () => {
    return isActive(store.getState());
};

export const checkInitialized = () => {
    return isInitialized(store.getState());
};

export const checkLoggedIn = () => {
    return isLoggedIn(store.getState());
};
export const checkHasPermission = (permission) => {
    const account = store.getState().accountState.get(Keys.StoreSliceData.ACCOUNT, Immutable.Map());
    return hasPermission(permission, account)
}


const mapStateToProps = (state) => {

    return {
        loginState: state.loginState,
        account: state.accountState.get(Keys.StoreSliceData.ACCOUNT, Immutable.Map()),
        isLoggedIn: () => isLoggedIn(state),
        isActive:  () => isActive(state),
        isInitialized: () => isInitialized(state),
    }
};

class Require extends React.Component {
    render() {
        const props = this.props;
        let alternative = null;
        let required = props.children;
        if (React.Children.count(props.children) > 1) {
            const childArray = React.Children.toArray(props.children);
            required = childArray[0];
            // Use the second child if condition fails
            alternative = childArray[1];
        }
        if (props.loggedIn && !props.isLoggedIn()) {
            // console.warn("Not logged in as required");
            return alternative;
        }
        if (props.initialized && !props.isInitialized()) {
            // console.warn("Not initialized in as required");
            return alternative;
        }
        if (props.active && !props.isActive()) {
            // console.warn("Not active in as required");
            return alternative;
        }
        if( !hasPermission(props.permission, props.account)) {
            // console.warn("Lacking permission:["+props.permission+"] as required");
            return alternative;
        }
        return required;
    }
}

export default connect(mapStateToProps, {})(Require);

Require.propTypes = {
    loginState: ImmutablePropTypes.map.isRequired,
    account: ImmutablePropTypes.map.isRequired,
    loggedIn: React.PropTypes.bool,
    initialized: React.PropTypes.bool,
    active: React.PropTypes.bool,
    permission: React.PropTypes.string,
    isLoggedIn: React.PropTypes.func.isRequired,
    isActive: React.PropTypes.func.isRequired,
    isInitialized: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/components/Require.js